import dayjs from "dayjs";
const utc = require("dayjs/plugin/utc");

dayjs.extend(utc);

export const formatDateAndTime = (value, format = "D MMM YYYY") =>
  dayjs(value).format(format);
